//path: src\store\store.tsx

import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootState';

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
